import React, { useEffect, useReducer, useRef  } from "react";

// Interface for component props
interface SellingButtonProps {
	text: string;
	onClick?: () => void;
}

export const SellingButton = ( props: SellingButtonProps ) => {

	return(
		<p className={"selling-btn"} onClick={ props.onClick }>{ props.text }</p>
	);
};